module.exports = __webpack_public_path__ + "img/map-east-africa.ec815862.png";